export const clone = <T>(data: T) => structuredClone(data) as T;
